import { useSelector } from "react-redux";
import { selectSelectedThreadId } from "./messagingThreadSlice";

export const useThreads = () => {
  const selectedThreadId = useSelector(selectSelectedThreadId);
  return { selectedThreadId };
};
